<template>
    <div>
        <masternav/>
        <b-container class="mt-5">
            <br><br>
            <h1 class="titlequestion ml-5 mr-5 text-center">¿Olvidó su contraseña?</h1>
            <div class="ml-5 mr-5 navtext2 text-center">
          <h5>
            Ingrese el correo electrónico con el que se registró
          </h5>
        </div>
            <b-row>
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col lg="12">
                                <b-form-group label="correo electrónico" label-for="contrato" description="">
                                    <b-form-input id="contrato" type="email" required placeholder="" v-model="email">
                                    </b-form-input>
                                    </b-form-group>
                                    <b-button block squared class="button" @click.prevent="solicitudCambioPassword" :disabled="sending">
                                        <span v-if="sending">{{ text1 }}</span>
                                        <span v-else>{{ text }}</span>
                                        <b-spinner v-show="sending" small label="Small Spinner"></b-spinner>
                                    </b-button>
                                </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <br><br>
        <contactcomp/>
        <mainfooter/>
    </div>
</template>

<script>
import masternav from '@/components/masternav.vue'
import Mainfooter from '../components/mainfooter.vue'
import Contactcomp from '../components/contactcomp.vue'
import { mapState } from 'vuex'
import axios from 'axios'
    export default {
        components: {
            masternav,
            Contactcomp,
            Mainfooter
        },
        mounted () {
            if (!this.modoClientes) {
                this.$router.push('/')
            }
        },
        data() {
            return {
                email:'',
                sending:false,
                text:'Enviar Solicitud',
                text1:'enviando solicitud...'
            }
        },
        computed: {
            ...mapState('autenticacion', ['modoClientes'])
        },
        methods: {
            solicitudCambioPassword() {

                this.sending = !this.sending

                axios.post('password/email', {'email': this.email}).then(resp=>{
                    if (resp.status == 200) {
                        this.$bvToast.toast('Se ha enviado la url de recuperación a su correo', {
                        variant: 'success',
                        title:false,
                        solid: true
                        }) 
                        this.sending = !this.sending
                    }
                    this.email = ''
                }).catch(e=>{
                    this.sending = !this.sending
                    this.email = ''
                    if(e.response.status == 422)
                    {
                       this.$bvToast.toast('Ha enviado una solicitud recientemente', {
                        variant: 'warning',
                        title:false,
                        solid: true
                        })  
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>